import { useEffect, useState } from 'react';

export const MOBILE_QUERY = '(max-width: 768px)';
export const COMPACT_QUERY = '(max-width: 1199px)';

const matches = (query) =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia(query).matches
        : false;

/**
 * 编辑器的响应式断点
 * - isMobile：≤768px，大纲和工具面板都收进抽屉，正文全宽
 * - isCompact：≤1199px，大纲改为抽屉，工具面板仍固定在右侧
 */
export function useBreakpoint() {
    const [state, setState] = useState(() => ({
        isMobile: matches(MOBILE_QUERY),
        isCompact: matches(COMPACT_QUERY),
    }));

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
        const mobile = window.matchMedia(MOBILE_QUERY);
        const compact = window.matchMedia(COMPACT_QUERY);
        const update = () => setState({ isMobile: mobile.matches, isCompact: compact.matches });
        update();
        const add = (mql) =>
            mql.addEventListener ? mql.addEventListener('change', update) : mql.addListener(update);
        const remove = (mql) =>
            mql.removeEventListener
                ? mql.removeEventListener('change', update)
                : mql.removeListener(update);
        add(mobile);
        add(compact);
        return () => {
            remove(mobile);
            remove(compact);
        };
    }, []);

    return state;
}
